import { useAppMessages } from 'hooks/useAppMessages';
import { useIntl } from 'react-intl';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { ReadingGroupsHooks as messages } from 'routes/reading_groups/messages';
import {
  DeleteInventoryMeterReadingGroupArgs,
  DeleteInventoryMeterReadingGroupResponse,
} from 'services/api/inventoryMeterReadingGroups';
import { useServices } from 'services/useServices';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useDeleteInventoryMeterReadingGroup = (): UseMutationResult<
  DeleteInventoryMeterReadingGroupResponse,
  unknown,
  DeleteInventoryMeterReadingGroupArgs
> => {
  const intl = useIntl();
  const {
    api: { inventoryMeterReadingGroupsApiClient },
  } = useServices();
  const queryClient = useQueryClient();
  const appMessages = useAppMessages();

  return useMutation({
    mutationKey: MUTATION_KEYS.inventoryMeterReadingGroups.delete(),
    mutationFn: async ({ id }: DeleteInventoryMeterReadingGroupArgs) => inventoryMeterReadingGroupsApiClient.delete(id),
    onSuccess: () => {
      appMessages.success(intl.formatMessage(messages.deleteGroupSuccess));
      queryClient.invalidateQueries(QUERY_KEYS.inventoryMeterReadingGroups.all());
    },
    onError: () => {
      appMessages.error(intl.formatMessage(messages.deleteGroupError));
    },
  });
};
